import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  dcTitle: 'Delete contact',
  dcSubtitle: 'Are you sure you want to delete this contact?',
  dcConfirm:
    'You will delete <strong>{{contactName}}</strong> from your contacts list.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const DELETE_CONTACT_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    dcTitle: 'Eliminar contacto',
    dcSubtitle: '¿Estás seguro de que deseas eliminar este contacto?',
    dcConfirm:
      'Eliminarás a <strong>{{contactName}}</strong> de tu lista de contactos.',
  },
};

export default DELETE_CONTACT_LANGUAGE_LABELS;
